<template>
    <div>
        <SimpleTablePage
            pageTitle="参数管理"
            :columns="columns"
            :pageLength="pageLength"
            :pageLengthRank="pageLengthRank"
            :total="total"
            :dataset="dataset"
            :filters="searchFilter"
            :footerOperationBtns="bottomButtons"
            :isHideFooter="false"
            @filterChange="filterFieldsChange"
            @pageChange="pageChange"
            @columnClick="columnClick"
            @bottomClick="bottomClick"
            @selectionChange="selectionChange"
        >
            <span class="sp-describe" slot="describe">
                共<span>{{ total }}</span>
                条参数
            </span>
            <el-dropdown slot="operation" split-button type="primary" class="add-parmas-btn" @command="handleCommand">
                添加参数
                <el-dropdown-menu class="params-dropdown" slot="dropdown">
                    <el-dropdown-item command="0">客户端参数</el-dropdown-item>
                    <!-- <el-dropdown-item command="1">API参数</el-dropdown-item>
                    <el-dropdown-item command="2">数据平台清洗参数</el-dropdown-item>
                    <el-dropdown-item command="3">自定义参数</el-dropdown-item> -->
                </el-dropdown-menu>
            </el-dropdown>
        </SimpleTablePage>
        <el-dialog title="提示" width="25%" :visible.sync="delModalVisible">
            <div class="dialog-content">
                <i class="icon icon-tip"></i>
                目前有标签正在使用该参数，因此无法删除参数。请先将相关标签下线或删除。
                <el-link @click="redirectTags" :underline="false" :style="{ color: '#2EC2FF' }">立刻查看标签 ></el-link>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" round @click="delModalVisible = false">知道啦</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SimpleTablePage from "@/views/zhiji/templates/simpleTablePage/index.vue";
import { columns, pageLength, pageLengthRank, searchFilter, bottomButtons } from "./config";
import { queryParamsList, isReference, delParams } from "./server";
import AddParamsModal from "./components/AddParamsModal.vue";
import EditParamsModal from "./components/EditParamsModal.vue";

export default {
    name: "PortraitParams",
    components: { SimpleTablePage },
    data() {
        return {
            columns,
            curPage: 1,
            pageLength,
            pageLengthRank,
            searchFilter,
            bottomButtons,
            total: 0,
            dataset: [],
            queryData: {
                filterFields: {}
            },
            delModalVisible: false,
            selectIds: [],
            useIds: [],
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        }
    },
    mounted() {
        this.queryParamsList();
    },
    methods: {
        async queryParamsList() { 
            this.dataset = [];
            const { list = [], count = 0 } = await queryParamsList({
                page: this.curPage,
                size: this.pageLength,
                gameId: this.gameId,
                ...this.queryData.filterFields
            });
            this.dataset = list;
            this.total = count;
        },
        addParams() {
            // 添加参数弹窗
            this.$store.commit("zhiji/showModal", {
                type: AddParamsModal,
                data: {
                    confirm: () => {
                        this.queryParamsList()
                    },
                }
            })
        },
        editParams(rowData) {
            // 添加参数弹窗
            this.$store.commit("zhiji/showModal", {
                type: EditParamsModal,
                data: {
                    rowData,
                    confirm: () => {
                        this.queryParamsList();
                    },
                    cancel: () => {},
                }
            })
        },
        filterFieldsChange(data) {
            this.queryData.filterFields = data.filterFields;
            this.queryParamsList();
        },
        pageChange(data) {
            const { curPage, pageLength } = data;
            this.curPage = curPage;
            this.pageLength = pageLength;
            this.queryParamsList();
        },
        async columnClick(data) {
            if (data.colId === "name") {
                this.editParams(data.rowData);
            }
            if (data.colId === "Operation") {
                this.delParams(data.rowData.id);
            }
        },
        async delParams(ids) {
            // 判断是否有标签在使用
            const param = {
                gameId: this.gameId,
                ids: ids
            }
            const res = await isReference(param);
            if (res.length > 0) {
                this.useIds = [];
                this.useIds = res;
                this.delModalVisible = true;
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: `确定删除已选参数吗？`,
                        confirm: async () => {
                            await delParams(param);
                            this.queryParamsList();
                        }
                    },
                });
            }
        },
        async bottomClick({ data }) {
            if (this.selectIds.length === 0) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: "请至少选择一条参数",
                    },
                });
                return;
            }
            if (data.id === "del") {
                this.delParams(this.selectIds.join());
            }
        },
        selectionChange(data) {
            this.selectIds = data.map(item => item.id);
        },
        handleCommand(source) {
            if (source == 0) {
                // 暂时只做客户端参数
                this.addParams();
            }
        },
        redirectTags() {
            // 携带 被引用的参数id 跳转到标签页
            this.$router.push({
                path: "portraitTags",
                name: "portraitTags",
                params: {
                    ids: this.useIds,
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.sp-describe {
    font-weight: normal;
    margin-left: 24px;
    font-size: 14px;
    span {
        color: #26d485;
    }
}
.add-parmas-btn {
    ::v-deep .el-button-group {
        .el-button:first-child {
            border-radius: 30px 0 0 30px;
            min-width: 0px;
        }
        .el-button:last-child {
            border-radius: 0 30px 30px 0;
            min-width: 0px;
        }
    }
}
.dialog-content {
    width: 340px;
    font-size: 14px;
    margin: 20px auto;
    .icon {
        display: inline-block;
        width: 22px;
        height: 22px;
        margin-right: 15px;
        vertical-align: text-bottom;
    }
    .icon-tip {
        background: url("@{zhijiStaticImagePath}i-tip.png") no-repeat;
    }
}

</style>
<style>
.params-dropdown {
    left: 236px !important;
}
</style>